import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ChatService } from 'src/app/core/chat.service';
import { FlashcardService } from 'src/app/core/flashcard.service';
import { LearnsetService } from 'src/app/core/learnset.service';
import { Flashcard } from 'src/app/models/flashcard.model';

@Component({
  selector: 'app-create-flashcards-chat',
  templateUrl: './create-flashcards-chat.component.html',
  styleUrls: ['./create-flashcards-chat.component.scss'],
  standalone: false
})
export class CreateFlashcardsChatComponent {

  messages: { sender: 'user' | 'ai', content: string, pending: boolean }[] = [];
  text: string = '';
  learnsetId?: number;
  sessionId?: number;
  generatingFlashcards: boolean = false;
  flashcards: Flashcard[] = [];
  showFlashcards: boolean = false;
  isSavingFlashcards: boolean = false;

  constructor(private chatService: ChatService, private route: ActivatedRoute, private flashcardService: FlashcardService, private router: Router) {}

  ngOnInit() {
    this.learnsetId = Number(this.route.snapshot.paramMap.get('id')!);
    this.initSession();
    this.messages.push({ sender: 'ai', content: 'Hi, für welches Thema soll ich dir Lernkarten erstellen? Kleiner Tipp am Rande: die besten Ergebnisse bekommst du, wenn du mir eine Themenstruktur gibst. 😉', pending: false });
  }

  initSession() {
    this.chatService.initCreateFlashcardSession(this.learnsetId!).subscribe((result) => this.sessionId = result.sessionId);
  }

  handleSend() {
    if (this.flashcards?.length > 0) {
      this.flashcards = [];
    }
    this.messages.push({ sender: 'user', content: this.text.toString(), pending: false });
    setTimeout(() => {
      this.messages.push({ sender: 'ai', content: '...', pending: true });
    }, 1000);
    this.chatService.postCreateFlashcardMessage(this.sessionId!, this.text).subscribe((result) => {
      this.messages.pop();
      this.messages.push({ sender: 'ai', content: result.response, pending: false });

      if (result.generateFlashcards) {
        this.generatingFlashcards = true;
        this.generateFlashcards();
      }
    });
    this.text = '';
  }

  generateFlashcards() {
    this.chatService.generateChatFlashcards(this.sessionId!).subscribe((result) => {
      this.generatingFlashcards = false;
      this.flashcards = result.flashcards.map((flashcard: any) => Flashcard.constructFlashcard(flashcard));
    });
  }

  saveFlashcards() {
    this.isSavingFlashcards = true;
    this.chatService.saveChatFlashcards(this.sessionId!, this.flashcards).subscribe((result) => {
      this.showFlashcards = false;
      this.router.navigate(['sets/' + this.learnsetId]);
    });
  }

  displayFlashcards() {
    this.showFlashcards = true;
  }
}
